import React from "react";
import { observer } from "mobx-react-lite";
import { useRootStore } from "../../../../store/contexts";
import { ErrorDialog } from "../../../../common/controls";
import { UserAttachmentEditionListStore } from "../../store/UserAttachmentEditionListStore";

type UserAttachmentEditionListDialogsProps = {
  store: UserAttachmentEditionListStore;
};

/**
 * Componente que agrupa todos los dialogs del listado de UserAttachmentEdition.
 * Separado para mantener UserAttachmentEditionListPage más limpio.
 */
export const UserAttachmentEditionListDialogs: React.FC<UserAttachmentEditionListDialogsProps> =
  observer(({ store }) => {
    const { langStore } = useRootStore();

    return (
      <>
        {/* Dialog de error genérico */}
        <ErrorDialog
          open={store.errorDialogOpened}
          title={store.errorTitle || langStore.errorTitle}
          description={store.errorDescription}
          onClose={() => store.closeErrorDialog()}
        />
      </>
    );
  });
